export const FETCH_STORES_PENDING = "FETCH_STORES_PENDING";
export const FETCH_STORES_REJECTED = "FETCH_STORES_REJECTED";
export const FETCH_STORES_FULFILLED = "FETCH_STORES_FULFILLED";
export const AUTH_PENDING = "AUTH_PENDING";
export const AUTH_REJECTED = "AUTH_REJECTED";
export const FETCH_STAFFS_PENDING = "FETCH_STAFFS_PENDING";
export const FETCH_STAFFS_FULFILLED = "FETCH_STAFFS_FULFILLED";
export const ACTIVATE_STAFF_REJECTED = "ACTIVATE_STAFF_REJECTED";
export const ACTIVATE_STAFF_FULFILLED = "ACTIVATE_STAFF_FULFILLED";


// WEBPACK FOOTER //
// ./src/constants/auth.js